var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-row",
            { attrs: { center: "" } },
            [
              _c("h3", [_vm._v("Boekhouder dossiers")]),
              _c("w-spacer"),
              _c(
                "w-button-bar",
                [
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: !_vm.selectedDossierId },
                      on: {
                        click: function ($event) {
                          return _vm.add()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.selectedRows.length == 0 },
                      on: {
                        click: function ($event) {
                          return _vm.removeSelected()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "minus" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-input-autocomplete", {
            attrs: {
              fancy: "",
              label: "Zoek op dossier-naam, company-naam of ID",
              items: _vm.searchResults,
              "input-delay": 200,
            },
            on: {
              "realtime-value": _vm.onTextChange,
              input: _vm.doSearch,
              "item-click": _vm.onPick,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ item }) {
                  return [
                    _c("div", [
                      _c("strong", [_vm._v(_vm._s(item.Name))]),
                      _c("span", { staticClass: "mls" }, [
                        _vm._v("#" + _vm._s(item.ID)),
                      ]),
                    ]),
                    _c("div", { staticClass: "company-hint" }, [
                      _vm._v(
                        " " +
                          _vm._s(item.CompanyName) +
                          " (#" +
                          _vm._s(item.CompanyID) +
                          ") "
                      ),
                    ]),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _vm.dossiers.length
            ? _c("w-data-table", {
                attrs: {
                  items: _vm.dossiers,
                  columns: _vm.columns,
                  "selected-items": _vm.selectedRows,
                },
                on: { "item-clicked": _vm.onRowClick },
              })
            : _c("p", [_vm._v(" Geen dossiers gekoppeld. ")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }